/** ISO 3166-1 alpha-2 → flag emoji (e.g. "GB" → 🇬🇧) */
export function countryFlag(countryCode) {
  if (!countryCode || countryCode.length !== 2) return '🏳️'
  const code = countryCode.toUpperCase()
  return String.fromCodePoint(
    ...[...code].map((char) => 0x1f1e6 + char.charCodeAt(0) - 65),
  )
}
